import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class ContactContent extends React.PureComponent<ContactContent.Props, ContactContent.State> {
  public static sectionId = 'contact';

  public render(): JSX.Element {
    const { section, data } = this.props
    const { settings, blocks } = section
    return (
      <section className={'dynamic-content-contact'}>
        <div className={'max-w-7xl mx-auto px-1-6 md:px-3-2 xl:px-0 pt-3-2 sm:pt-4 flex flex-wrap'}>
          <div className={'w-full md:px-4-8 lg:px-0 lg:w-1/2 flex flex-wrap sm:mb-0 mb-0-8'}>
            <div className={'w-full md:w-1/2'}>
              {
                blocks.map((block) => block.settings.column === '1' ? this.buildContent(block.settings) : null)
              }
            </div>
            <div className={'w-full md:w-1/2 md:pl-0-6'}>
              {
                blocks.map((block) => block.settings.column === '2' ? this.buildContent(block.settings) : null)
              }
            </div>
          </div>
          <div className={'w-full md:px-4-8 lg:px-0 lg:w-1/2'}>
            <div className={'w-full lg:w-2/3 lg:mx-auto lg:pl-1-4'}>

                {data.form.contact.posted_successfully ? (
                  <div className={'w-full pt-2 pb-2-8 md:pt-0 pb-0 flex flex-col justify-center items-center text-center'}>
                    <Snippets.Heading
                      size={window.innerWidth < 768 ? 'h2' : 'h1'}
                      tag={'p'}
                      className={'mb-1-6 md:mb-2-4'}
                    >
                      {settings.successtitle ? settings.successtitle : 'Thank you for contacting'}
                    </Snippets.Heading>
                    <Snippets.Heading
                      size={'p'}
                      tag={'p'}
                      className={'flex-1'}
                    >
                      {settings.successcontent ? settings.successcontent : 'We will get back to you soon'}
                    </Snippets.Heading>
                  </div>
                ) : (
                  <ShopifyNext.Components.Forms
                  data={data.form.contact}
                  className={'block'}
                >
                  <Snippets.FormErrors form={data.form.contact} />
                    <Snippets.Heading tag={'h3'} size={'h3'} className={'mb-2-4 leading-close'}>
                      {'Send an Enquiry'}
                    </Snippets.Heading>
                    <div className={'block mb-4 sm:mb-6-4'}>
                      <Snippets.Input
                        name="contact[first_name]"
                        id="first_name"
                        type="text"
                        hideLabel
                        className={'mb-1-6 border border-grey-border'}
                        placeholder="First name"
                        required
                      />
                      <Snippets.Input
                        name="contact[last_name]"
                        id="last_name"
                        type="text"
                        hideLabel
                        className={'mb-1-6 border border-grey-border'}
                        placeholder="Last name"
                        required
                      />
                      <Snippets.Input
                        name="contact[email]"
                        id="email"
                        type="email"
                        hideLabel
                        className={'mb-1-6 border border-grey-border'}
                        placeholder="Email address"
                        required
                      />
                      <Snippets.Input
                        name="contact[phone_number]"
                        id="phone_number"
                        type="tel"
                        hideLabel
                        className={'mb-1-6 border border-grey-border'}
                        placeholder="Phone number"
                        required
                      />
                      <div className={'flex mb-1-6'}>
                        <textarea
                          name="contact[Message]"
                          placeholder="Enter Comment"
                          rows={3}
                          className={'w-full block relative w-full h-full py-1-3 px-1-6 outline-none focus:outline-none border border-grey-border'}
                          required
                        />
                      </div>
                      <div className={'flex mb-0-6'}>
                        <Snippets.Button
                          title={'Submit'}
                          type={'submit'}
                          className={'w-full uppercase py-0-8 flex items-center'}
                        >
                          <span className={'flex-1 text-left'}>{'Submit'}</span>
                          <Snippets.Icon name={'arrow_right'} width={40} />
                        </Snippets.Button>
                      </div>
                    </div>
                    </ShopifyNext.Components.Forms>)}
            </div>
          </div>
        </div>
      </section>
    )
  }

  private buildContent(block) {
    return (
      <div className={'mb-3-2'}>
        <Snippets.Heading tag={'h3'} size={'h3'} className={'mb-1-7 tracking-wider leading-close'}>
          {block.title}
        </Snippets.Heading>
        <Snippets.RichText size={'p'} className={'leading-close'}>
          {block.contentrichtext}
        </Snippets.RichText>
      </div>
    )
  }
}

export namespace ContactContent {
  export interface Options extends ShopifyNext.Section<{
    successtitle?: string;
    successcontent?: string;
  }> {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: ContactContent.Options;
  }
  export interface State { }
}
